// Task Board (64_TaskBoard.jsx), 2026-10-30 — a Kanban board per person; tasks given, shared, whole boards shared.
const en = {
  f_repeat: 'Repeats',
  r_none: 'Does not repeat',
  r_week: 'Weekly',
  r_month: 'Monthly',
  r_quarter: 'Quarterly',
  r_year: 'Yearly',
  r_every: 'Every',
  u_week: 'week(s)',
  u_month: 'month(s)',
  u_quarter: 'quarter(s)',
  u_year: 'year(s)',
  r_until: 'Until',
  r_next: 'Next one due {{date}} — made by itself when this one is Done.',
  r_needDate: 'Set a due date so the next ones land on the right day.',
  r_everyN: 'Every {{n}} {{unit}}',
  noteNext: 'The next "{{title}}" is on the board — due {{date}}.',
  log_repeat: 'repeat',
  tl_next: 'Next time',
  tl_day: 'Days',
  tl_wd: 'Mo,Tu,We,Th,Fr,Sa,Su',
  view: 'View',
  v_board: 'Board',
  v_timeline: 'Timeline',
  tl_week: 'Weeks',
  tl_month: 'Months',
  tl_open: 'still open',
  tl_days: 'days',
  tl_late: '{{n}} days past due',
  tl_today: 'Today',
  tl_rule: 'A bar runs from the request date to the day it was done, else its due date, else request date + estimated days; without any, up to today.',
  f_est: 'Estimated days to finish',
  f_estPh: 'e.g. 2 or 0.5',
  estN: '{{n}} d',
  f_requested: 'Request date',
  delTitle: 'Delete this task?',
  sortMine: 'My order',
  sortDue: 'By due date',
  sortPrio: 'By priority',
  createAgain: 'Create & add another',
  madeN: '{{n}} created',
  nav: 'System Project',
  title: 'System Project',
  sub: 'Your tasks and the ones given to you, by stage. Drag a card to move it; share a task, or your whole board, so others can see or edit it.',
  myBoard: 'My tasks',
  boardOf: "{{name}}'s board",
  sharedWithMe: 'Shared with me',
  newTask: 'New task',
  shareBoard: 'Share my board',
  search: 'Search tasks…',
  allPrio: 'Any priority',
  onlyUrgent: 'Urgent & high',
  anyone: 'Anyone',
  assignedMe: 'Given to me',
  createdMe: 'Made by me',
  col_backlog: 'Backlog',
  col_todo: 'To do',
  col_doing: 'In progress',
  col_review: 'Review',
  col_done: 'Done',
  addHere: 'Add a task here',
  quickPh: 'Task title, then Enter',
  completed: 'Completed',
  overdue: 'Overdue',
  dueToday: 'Due today',
  p_normal: 'Normal',
  p_low: 'Low',
  p_high: 'High',
  p_urgent: 'Urgent',
  noTasks: 'Nothing here yet.',
  readOnly: 'Shared with you to read',
  f_title: 'Title',
  f_body: 'Description',
  f_status: 'Stage',
  f_priority: 'Priority',
  f_due: 'Due date',
  f_noRush: 'No rush', f_noRushHint: 'Not urgent — whoever does it picks a planned date', f_planned: 'Planned date', frequent: 'Frequent',
  f_dueNone: 'no date — as soon as possible',
  f_assignee: 'Given to',
  f_nobody: 'Nobody (me)',
  f_tags: 'Tags',
  f_tagsPh: 'comma separated, e.g. Costing, Q4',
  f_checklist: 'Checklist',
  f_addCheck: 'Add an item',
  f_share: 'Shared with',
  f_shareAdd: 'Add a person…',
  f_canEdit: 'can edit',
  f_canView: 'can view',
  f_comments: 'Comments',
  f_commentPh: 'Write a comment…',
  f_send: 'Send',
  f_history: 'History',
  f_owner: 'Made by {{name}}',
  save: 'Save',
  create: 'Create task',
  cancel: 'Cancel',
  close: 'Close',
  del: 'Delete',
  delAsk: 'Delete "{{title}}"? It leaves every board.',
  saved: 'Saved.',
  boardShareTitle: 'Share my board',
  boardShareSub: 'These people see every task you made or were given. "Can edit" lets them change the tasks too.',
  boardShareSaved: 'Board sharing saved.',
  remove: 'Remove',
  needTitle: 'Give the task a title.',
  loading: 'Loading…',
  failed: 'Something went wrong ({{status}})',
  nameLess: '(no name)',
  checkCount: '{{done}}/{{all}}',
  log_created: 'created',
  log_edited: 'edited',
  log_moved: 'moved',
  log_deleted: 'deleted',
  f_files: 'Files & images',
  f_attach: 'Attach',
  f_filesHint: 'or drop files here, or paste a screenshot (Ctrl+V) — up to 20 MB each',
  f_pending: 'uploads on Create',
  f_tooBig: 'A file can be up to 20 MB.',
  noAccess: 'no access',
  noAccessHint: 'This person does not have System Project: their name is on the task, but they get no notification and cannot open it.',
  log_file: 'attached',
  log_unfile: 'removed a file',
  v_day: 'My day',
  d_moved: 'moved {{from}} → {{to}}',
  d_created: 'created',
  d_comment: 'commented: {{text}}',
  d_file: 'attached {{name}}',
  d_unfile: 'removed {{name}}',
  d_edited: 'updated {{what}}',
  d_saved: 'saved the task',
  c_edit: 'Edit',
  c_edited: 'edited',
  c_editHint: 'Enter to save · Esc to cancel',
  log_comment_edit: 'changed a comment',
  d_commentEdit: 'changed a comment',
  d_prev: 'Previous day',
  d_next: 'Next day',
  d_today: 'Today',
  d_none: 'Nothing done on the board on {{date}}.',
  d_sTasks: 'tasks worked on',
  d_sDone: 'finished',
  d_sNew: 'created',
  d_sMoved: 'moves',
  d_sComments: 'comments',
  d_sFiles: 'files',
  // suggestions from email and chat (taskInbox, 31/10)
  in_btn: "Suggestions",
  in_title: "Suggested from email and chat",
  in_sub: "Catchy reads your email, Google Chat and GCC rooms and lists the work it finds for you. Nothing goes on the board until you press Create task.",
  in_none: "No suggestions right now.",
  in_create: "Create task",
  in_dismiss: "Dismiss",
  in_open: "Open the message",
  in_runNow: "Read now",
  in_running: "Reading…",
  in_connect: "Connect Gmail & Google Chat",
  in_reconnect: "Reconnect Google",
  in_connected: "Connected as {{email}}",
  in_chatOff: "Google Chat not included",
  in_src_gmail: "Email",
  in_src_gchat: "Google Chat",
  in_src_gcc: "GCC",
  in_lastRun: "read {{when}}",
  in_err: "could not read: {{msg}}",
  in_notConnected: "not connected",
  in_why: "Why",
  in_from: "from {{who}}",
  in_me: "me",
  in_excerpt: "The message",
  in_ranN: "Read {{n}} message(s) — {{s}} new suggestion(s).",
  goneTitle: 'This task has been deleted',
  goneBody: '"{{title}}" was deleted by {{by}} on {{at}}.',
  goneBodyNoBy: '"{{title}}" has been deleted.',
  missingTitle: 'This task cannot be opened',
  missingBody: 'It does not exist, or it is not shared with you.',
  gotIt: 'OK',
};
const ko = {
  f_repeat: '반복',
  r_none: '반복 안 함',
  r_week: '매주',
  r_month: '매월',
  r_quarter: '분기마다',
  r_year: '매년',
  r_every: '간격',
  u_week: '주',
  u_month: '개월',
  u_quarter: '분기',
  u_year: '년',
  r_until: '종료일',
  r_next: '다음 업무 마감 {{date}} — 이 업무가 완료되면 자동으로 만들어집니다.',
  r_needDate: '다음 반복이 정확한 날에 오도록 마감일을 정하세요.',
  r_everyN: '{{n}}{{unit}}마다',
  noteNext: '다음 "{{title}}" 업무를 만들었습니다 — 마감 {{date}}.',
  log_repeat: '반복',
  tl_next: '다음 반복',
  tl_day: '일',
  tl_wd: '월,화,수,목,금,토,일',
  view: '보기',
  v_board: '보드',
  v_timeline: '타임라인',
  tl_week: '주',
  tl_month: '월',
  tl_open: '진행 중',
  tl_days: '일',
  tl_late: '마감 {{n}}일 지남',
  tl_today: '오늘',
  tl_rule: '막대는 요청일부터 완료일까지, 없으면 마감일, 없으면 요청일 + 예상 일수, 아무것도 없으면 오늘까지입니다.',
  f_est: '완료 예상 일수',
  f_estPh: '예: 2 또는 0.5',
  estN: '{{n}}일',
  f_requested: '요청일',
  delTitle: '이 업무를 삭제할까요?',
  sortMine: '내 순서',
  sortDue: '마감일순',
  sortPrio: '우선순위순',
  createAgain: '만들고 계속 추가',
  madeN: '{{n}}개 만듦',
  nav: '시스템 프로젝트',
  title: '시스템 프로젝트',
  sub: '내 업무와 받은 업무를 단계별로 봅니다. 카드를 끌어 옮기고, 업무나 보드 전체를 공유해 다른 사람이 보거나 수정할 수 있게 하세요.',
  myBoard: '내 업무',
  boardOf: '{{name}}의 보드',
  sharedWithMe: '나에게 공유됨',
  newTask: '새 업무',
  shareBoard: '내 보드 공유',
  search: '업무 검색…',
  allPrio: '모든 우선순위',
  onlyUrgent: '긴급 · 높음',
  anyone: '전체',
  assignedMe: '나에게 배정',
  createdMe: '내가 만든',
  col_backlog: '백로그',
  col_todo: '할 일',
  col_doing: '진행 중',
  col_review: '검토',
  col_done: '완료',
  addHere: '여기에 업무 추가',
  quickPh: '업무 제목 입력 후 Enter',
  completed: '완료됨',
  overdue: '기한 지남',
  dueToday: '오늘 마감',
  p_normal: '보통',
  p_low: '낮음',
  p_high: '높음',
  p_urgent: '긴급',
  noTasks: '아직 없습니다.',
  readOnly: '읽기 전용으로 공유됨',
  f_title: '제목',
  f_body: '설명',
  f_status: '단계',
  f_priority: '우선순위',
  f_due: '마감일',
  f_noRush: '급하지 않음', f_noRushHint: '급하지 않음 — 담당자가 계획일을 정합니다', f_planned: '계획일', frequent: '자주 선택',
  f_dueNone: '날짜 없음 — 가능한 빨리',
  f_assignee: '담당자',
  f_nobody: '없음 (나)',
  f_tags: '태그',
  f_tagsPh: '쉼표로 구분, 예: Costing, Q4',
  f_checklist: '체크리스트',
  f_addCheck: '항목 추가',
  f_share: '공유 대상',
  f_shareAdd: '사람 추가…',
  f_canEdit: '수정 가능',
  f_canView: '보기만',
  f_comments: '댓글',
  f_commentPh: '댓글 쓰기…',
  f_send: '보내기',
  f_history: '기록',
  f_owner: '{{name}} 님이 만듦',
  save: '저장',
  create: '업무 만들기',
  cancel: '취소',
  close: '닫기',
  del: '삭제',
  delAsk: '"{{title}}"을(를) 삭제할까요? 모든 보드에서 사라집니다.',
  saved: '저장했습니다.',
  boardShareTitle: '내 보드 공유',
  boardShareSub: '이 사람들은 내가 만들었거나 받은 모든 업무를 봅니다. "수정 가능"이면 업무를 바꿀 수도 있습니다.',
  boardShareSaved: '보드 공유를 저장했습니다.',
  remove: '빼기',
  needTitle: '업무 제목을 입력하세요.',
  loading: '불러오는 중…',
  failed: '문제가 생겼습니다 ({{status}})',
  nameLess: '(이름 없음)',
  checkCount: '{{done}}/{{all}}',
  log_created: '만듦',
  log_edited: '수정',
  log_moved: '이동',
  log_deleted: '삭제',
  f_files: '파일 · 이미지',
  f_attach: '첨부',
  f_filesHint: '또는 파일을 여기로 끌어오거나 스크린샷 붙여넣기(Ctrl+V) — 파일당 20 MB까지',
  f_pending: '만들 때 업로드',
  f_tooBig: '파일은 20 MB까지 올릴 수 있습니다.',
  noAccess: '권한 없음',
  noAccessHint: 'System Project 권한이 없는 사람입니다. 이름은 task에 남지만 알림을 받지 않고 열 수도 없습니다.',
  log_file: '첨부',
  log_unfile: '파일 삭제',
  v_day: '오늘 한 일',
  d_moved: '{{from}} → {{to}} 이동',
  d_created: '만듦',
  d_comment: '댓글: {{text}}',
  d_file: '{{name}} 첨부',
  d_unfile: '{{name}} 삭제',
  d_edited: '{{what}} 수정',
  d_saved: 'task 저장',
  c_edit: '수정',
  c_edited: '수정됨',
  c_editHint: 'Enter 저장 · Esc 취소',
  log_comment_edit: '댓글 수정',
  d_commentEdit: '댓글 수정',
  d_prev: '전날',
  d_next: '다음날',
  d_today: '오늘',
  d_none: '{{date}}에는 보드에서 한 일이 없습니다.',
  d_sTasks: '작업한 task',
  d_sDone: '완료',
  d_sNew: '만듦',
  d_sMoved: '이동',
  d_sComments: '댓글',
  d_sFiles: '파일',
  // suggestions from email and chat (taskInbox, 31/10)
  in_btn: "제안",
  in_title: "이메일·채팅에서 찾은 할 일",
  in_sub: "Catchy가 이메일, Google Chat, GCC 방을 읽고 내가 할 일을 찾아 보여줍니다. 작업 만들기를 누르기 전에는 보드에 아무것도 추가되지 않습니다.",
  in_none: "지금은 제안이 없습니다.",
  in_create: "작업 만들기",
  in_dismiss: "무시",
  in_open: "원본 메시지 열기",
  in_runNow: "지금 읽기",
  in_running: "읽는 중…",
  in_connect: "Gmail·Google Chat 연결",
  in_reconnect: "Google 다시 연결",
  in_connected: "{{email}}(으)로 연결됨",
  in_chatOff: "Google Chat 미포함",
  in_src_gmail: "이메일",
  in_src_gchat: "Google Chat",
  in_src_gcc: "GCC",
  in_lastRun: "{{when}} 읽음",
  in_err: "읽지 못함: {{msg}}",
  in_notConnected: "연결 안 됨",
  in_why: "이유",
  in_from: "보낸 사람 {{who}}",
  in_me: "나",
  in_excerpt: "메시지 내용",
  in_ranN: "메시지 {{n}}건을 읽음 — 새 제안 {{s}}건.",
  goneTitle: '삭제된 작업입니다',
  goneBody: '"{{title}}" 작업은 {{at}}에 {{by}} 님이 삭제했습니다.',
  goneBodyNoBy: '"{{title}}" 작업은 삭제되었습니다.',
  missingTitle: '이 작업을 열 수 없습니다',
  missingBody: '존재하지 않거나 공유되지 않은 작업입니다.',
  gotIt: '확인',
};
const vi = {
  f_repeat: 'Lặp lại',
  r_none: 'Không lặp',
  r_week: 'Hàng tuần',
  r_month: 'Hàng tháng',
  r_quarter: 'Hàng quý',
  r_year: 'Hàng năm',
  r_every: 'Mỗi',
  u_week: 'tuần',
  u_month: 'tháng',
  u_quarter: 'quý',
  u_year: 'năm',
  r_until: 'Đến ngày',
  r_next: 'Lần tới: hạn {{date}} — tự tạo khi việc này chuyển sang Xong.',
  r_needDate: 'Đặt Hạn để các lần sau rơi đúng ngày.',
  r_everyN: 'Mỗi {{n}} {{unit}}',
  noteNext: 'Đã tạo lần tiếp theo của "{{title}}" — hạn {{date}}.',
  log_repeat: 'lặp',
  tl_next: 'Lần tới',
  tl_day: 'Ngày',
  tl_wd: 'T2,T3,T4,T5,T6,T7,CN',
  view: 'Cách xem',
  v_board: 'Bảng',
  v_timeline: 'Timeline',
  tl_week: 'Tuần',
  tl_month: 'Tháng',
  tl_open: 'đang mở',
  tl_days: 'ngày',
  tl_late: 'trễ hạn {{n}} ngày',
  tl_today: 'Hôm nay',
  tl_rule: 'Thanh chạy từ ngày yêu cầu đến ngày xong; chưa xong thì đến hạn; không có hạn thì ngày yêu cầu + số ngày ước lượng; không có gì thì đến hôm nay.',
  f_est: 'Ước lượng số ngày hoàn thành',
  f_estPh: 'vd: 2 hoặc 0.5',
  estN: '{{n}} ngày',
  f_requested: 'Ngày yêu cầu',
  delTitle: 'Xoá việc này?',
  sortMine: 'Thứ tự của tôi',
  sortDue: 'Theo hạn',
  sortPrio: 'Theo ưu tiên',
  createAgain: 'Tạo & thêm tiếp',
  madeN: 'Đã tạo {{n}}',
  nav: 'Dự án hệ thống',
  title: 'Dự án hệ thống',
  sub: 'Việc của bạn và việc được giao cho bạn, theo từng bước. Kéo thẻ để chuyển cột; chia sẻ một việc, hoặc cả bảng, để người khác xem hoặc sửa.',
  myBoard: 'Việc của tôi',
  boardOf: 'Bảng của {{name}}',
  sharedWithMe: 'Được chia sẻ với tôi',
  newTask: 'Việc mới',
  shareBoard: 'Chia sẻ bảng của tôi',
  search: 'Tìm việc…',
  allPrio: 'Mọi mức ưu tiên',
  onlyUrgent: 'Gấp & cao',
  anyone: 'Tất cả',
  assignedMe: 'Được giao cho tôi',
  createdMe: 'Do tôi tạo',
  col_backlog: 'Tồn đọng',
  col_todo: 'Cần làm',
  col_doing: 'Đang làm',
  col_review: 'Đang xem lại',
  col_done: 'Xong',
  addHere: 'Thêm việc vào đây',
  quickPh: 'Tên việc rồi Enter',
  completed: 'Đã xong',
  overdue: 'Quá hạn',
  dueToday: 'Hạn hôm nay',
  p_normal: 'Bình thường',
  p_low: 'Thấp',
  p_high: 'Cao',
  p_urgent: 'Gấp',
  noTasks: 'Chưa có gì.',
  readOnly: 'Được chia sẻ để xem',
  f_title: 'Tên việc',
  f_body: 'Mô tả',
  f_status: 'Bước',
  f_priority: 'Ưu tiên',
  f_due: 'Hạn',
  f_noRush: 'Không gấp', f_noRushHint: 'Không gấp — người làm tự chọn ngày dự kiến', f_planned: 'Ngày dự kiến', frequent: 'Hay chọn',
  f_dueNone: 'không có ngày — càng sớm càng tốt',
  f_assignee: 'Giao cho',
  f_nobody: 'Không ai (tôi)',
  f_tags: 'Nhãn',
  f_tagsPh: 'cách nhau bằng dấu phẩy, vd: Costing, Q4',
  f_checklist: 'Danh sách kiểm',
  f_addCheck: 'Thêm mục',
  f_share: 'Chia sẻ với',
  f_shareAdd: 'Thêm người…',
  f_canEdit: 'được sửa',
  f_canView: 'chỉ xem',
  f_comments: 'Bình luận',
  f_commentPh: 'Viết bình luận…',
  f_send: 'Gửi',
  f_history: 'Lịch sử',
  f_owner: '{{name}} tạo',
  save: 'Lưu',
  create: 'Tạo việc',
  cancel: 'Huỷ',
  close: 'Đóng',
  del: 'Xoá',
  delAsk: 'Xoá "{{title}}"? Việc này sẽ biến mất khỏi mọi bảng.',
  saved: 'Đã lưu.',
  boardShareTitle: 'Chia sẻ bảng của tôi',
  boardShareSub: 'Những người này thấy mọi việc bạn tạo hoặc được giao. "Được sửa" cho phép họ sửa việc.',
  boardShareSaved: 'Đã lưu chia sẻ bảng.',
  remove: 'Bỏ',
  needTitle: 'Đặt tên cho việc.',
  loading: 'Đang tải…',
  failed: 'Có lỗi ({{status}})',
  nameLess: '(không tên)',
  checkCount: '{{done}}/{{all}}',
  log_created: 'tạo',
  log_edited: 'sửa',
  log_moved: 'chuyển',
  log_deleted: 'xoá',
  f_files: 'File & hình ảnh',
  f_attach: 'Đính kèm',
  f_filesHint: 'hoặc kéo file vào đây, hoặc dán ảnh chụp màn hình (Ctrl+V) — tối đa 20 MB mỗi file',
  f_pending: 'tải lên khi bấm Tạo',
  f_tooBig: 'Mỗi file tối đa 20 MB.',
  noAccess: 'chưa có quyền',
  noAccessHint: 'Người này chưa có quyền System Project: tên vẫn ghi trên task, nhưng không nhận thông báo và không mở được task.',
  log_file: 'đính kèm',
  log_unfile: 'gỡ file',
  v_day: 'Trong ngày',
  d_moved: 'chuyển {{from}} → {{to}}',
  d_created: 'tạo mới',
  d_comment: 'bình luận: {{text}}',
  d_file: 'đính kèm {{name}}',
  d_unfile: 'gỡ {{name}}',
  d_edited: 'cập nhật {{what}}',
  d_saved: 'lưu task',
  c_edit: 'Sửa',
  c_edited: 'đã sửa',
  c_editHint: 'Enter để lưu · Esc để huỷ',
  log_comment_edit: 'sửa bình luận',
  d_commentEdit: 'sửa bình luận',
  d_prev: 'Ngày trước',
  d_next: 'Ngày sau',
  d_today: 'Hôm nay',
  d_none: 'Ngày {{date}} chưa có thao tác nào trên board.',
  d_sTasks: 'task đã làm',
  d_sDone: 'hoàn thành',
  d_sNew: 'tạo mới',
  d_sMoved: 'lần chuyển cột',
  d_sComments: 'bình luận',
  d_sFiles: 'file',
  // suggestions from email and chat (taskInbox, 31/10)
  in_btn: "Đề xuất",
  in_title: "Việc tìm thấy trong email và chat",
  in_sub: "Catchy đọc email, Google Chat và các room GCC của bạn rồi liệt kê việc bạn cần làm. Không có gì lên board cho đến khi bạn bấm Tạo task.",
  in_none: "Hiện chưa có đề xuất nào.",
  in_create: "Tạo task",
  in_dismiss: "Bỏ qua",
  in_open: "Mở tin gốc",
  in_runNow: "Đọc ngay",
  in_running: "Đang đọc…",
  in_connect: "Kết nối Gmail & Google Chat",
  in_reconnect: "Kết nối lại Google",
  in_connected: "Đã kết nối: {{email}}",
  in_chatOff: "chưa gồm Google Chat",
  in_src_gmail: "Email",
  in_src_gchat: "Google Chat",
  in_src_gcc: "GCC",
  in_lastRun: "đọc lúc {{when}}",
  in_err: "không đọc được: {{msg}}",
  in_notConnected: "chưa kết nối",
  in_why: "Lý do",
  in_from: "từ {{who}}",
  in_me: "tôi",
  in_excerpt: "Nội dung tin",
  in_ranN: "Đã đọc {{n}} tin — {{s}} đề xuất mới.",
  goneTitle: 'Task này đã bị xóa',
  goneBody: '"{{title}}" đã bị {{by}} xóa lúc {{at}}.',
  goneBodyNoBy: '"{{title}}" đã bị xóa.',
  missingTitle: 'Không mở được task này',
  missingBody: 'Task không tồn tại, hoặc chưa được chia sẻ với anh chị.',
  gotIt: 'OK',
};
const zh = {
  f_repeat: '重复',
  r_none: '不重复',
  r_week: '每周',
  r_month: '每月',
  r_quarter: '每季度',
  r_year: '每年',
  r_every: '每',
  u_week: '周',
  u_month: '个月',
  u_quarter: '季度',
  u_year: '年',
  r_until: '截止到',
  r_next: '下一次截止 {{date}} — 本任务完成时自动创建。',
  r_needDate: '请设置截止日期，以便后续任务落在正确的日期。',
  r_everyN: '每 {{n}} {{unit}}',
  noteNext: '已创建下一次"{{title}}" — 截止 {{date}}。',
  log_repeat: '重复',
  tl_next: '下一次',
  tl_day: '日',
  tl_wd: '一,二,三,四,五,六,日',
  view: '视图',
  v_board: '看板',
  v_timeline: '时间线',
  tl_week: '周',
  tl_month: '月',
  tl_open: '进行中',
  tl_days: '天',
  tl_late: '逾期 {{n}} 天',
  tl_today: '今天',
  tl_rule: '横条从请求日期到完成日；未完成则到截止日期；无截止日期则为请求日期 + 预计天数；都没有则到今天。',
  f_est: '预计完成天数',
  f_estPh: '例如 2 或 0.5',
  estN: '{{n}} 天',
  f_requested: '请求日期',
  delTitle: '删除这个任务？',
  sortMine: '我的顺序',
  sortDue: '按截止日期',
  sortPrio: '按优先级',
  createAgain: '创建并继续添加',
  madeN: '已创建 {{n}} 个',
  nav: '系统项目',
  title: '系统项目',
  sub: '你的任务和分配给你的任务，按阶段排列。拖动卡片即可移动；共享单个任务或整个看板，让他人查看或编辑。',
  myBoard: '我的任务',
  boardOf: '{{name}} 的看板',
  sharedWithMe: '共享给我',
  newTask: '新任务',
  shareBoard: '共享我的看板',
  search: '搜索任务…',
  allPrio: '任意优先级',
  onlyUrgent: '紧急和高',
  anyone: '全部',
  assignedMe: '分配给我',
  createdMe: '我创建的',
  col_backlog: '待办池',
  col_todo: '待做',
  col_doing: '进行中',
  col_review: '审核',
  col_done: '完成',
  addHere: '在此添加任务',
  quickPh: '输入任务标题后按 Enter',
  completed: '已完成',
  overdue: '已逾期',
  dueToday: '今天到期',
  p_normal: '普通',
  p_low: '低',
  p_high: '高',
  p_urgent: '紧急',
  noTasks: '暂无。',
  readOnly: '仅共享查看',
  f_title: '标题',
  f_body: '描述',
  f_status: '阶段',
  f_priority: '优先级',
  f_due: '截止日期',
  f_noRush: '不急', f_noRushHint: '不急 — 由执行人自定计划日期', f_planned: '计划日期', frequent: '常用',
  f_dueNone: '无日期 — 尽快',
  f_assignee: '分配给',
  f_nobody: '无（我自己）',
  f_tags: '标签',
  f_tagsPh: '用逗号分隔，例如 Costing, Q4',
  f_checklist: '检查清单',
  f_addCheck: '添加一项',
  f_share: '共享给',
  f_shareAdd: '添加人员…',
  f_canEdit: '可编辑',
  f_canView: '仅查看',
  f_comments: '评论',
  f_commentPh: '写评论…',
  f_send: '发送',
  f_history: '记录',
  f_owner: '由 {{name}} 创建',
  save: '保存',
  create: '创建任务',
  cancel: '取消',
  close: '关闭',
  del: '删除',
  delAsk: '删除"{{title}}"？它将从所有看板中消失。',
  saved: '已保存。',
  boardShareTitle: '共享我的看板',
  boardShareSub: '这些人能看到你创建或被分配的所有任务。"可编辑"表示他们也能修改任务。',
  boardShareSaved: '看板共享已保存。',
  remove: '移除',
  needTitle: '请填写任务标题。',
  loading: '加载中…',
  failed: '出现问题（{{status}}）',
  nameLess: '（无名）',
  checkCount: '{{done}}/{{all}}',
  log_created: '创建',
  log_edited: '编辑',
  log_moved: '移动',
  log_deleted: '删除',
  f_files: '文件和图片',
  f_attach: '附件',
  f_filesHint: '或把文件拖到这里，或粘贴截图（Ctrl+V）— 每个最多 20 MB',
  f_pending: '创建时上传',
  f_tooBig: '每个文件最多 20 MB。',
  noAccess: '无权限',
  noAccessHint: '此人没有 System Project 权限：名字会留在任务上，但不会收到通知，也无法打开。',
  log_file: '添加附件',
  log_unfile: '删除文件',
  v_day: '今日',
  d_moved: '从 {{from}} 移到 {{to}}',
  d_created: '创建',
  d_comment: '评论：{{text}}',
  d_file: '添加附件 {{name}}',
  d_unfile: '删除 {{name}}',
  d_edited: '更新 {{what}}',
  d_saved: '保存任务',
  c_edit: '编辑',
  c_edited: '已编辑',
  c_editHint: 'Enter 保存 · Esc 取消',
  log_comment_edit: '修改了评论',
  d_commentEdit: '修改了评论',
  d_prev: '前一天',
  d_next: '后一天',
  d_today: '今天',
  d_none: '{{date}} 在看板上没有操作。',
  d_sTasks: '处理的任务',
  d_sDone: '完成',
  d_sNew: '创建',
  d_sMoved: '移动',
  d_sComments: '评论',
  d_sFiles: '文件',
  // suggestions from email and chat (taskInbox, 31/10)
  in_btn: "建议",
  in_title: "从邮件和聊天中找到的任务",
  in_sub: "Catchy 读取你的邮件、Google Chat 和 GCC 群聊，列出需要你做的事。点击“创建任务”之前，不会有任何内容加入看板。",
  in_none: "目前没有建议。",
  in_create: "创建任务",
  in_dismiss: "忽略",
  in_open: "打开原消息",
  in_runNow: "立即读取",
  in_running: "读取中…",
  in_connect: "连接 Gmail 和 Google Chat",
  in_reconnect: "重新连接 Google",
  in_connected: "已连接：{{email}}",
  in_chatOff: "未包含 Google Chat",
  in_src_gmail: "邮件",
  in_src_gchat: "Google Chat",
  in_src_gcc: "GCC",
  in_lastRun: "{{when}} 已读取",
  in_err: "无法读取：{{msg}}",
  in_notConnected: "未连接",
  in_why: "原因",
  in_from: "来自 {{who}}",
  in_me: "我",
  in_excerpt: "消息内容",
  in_ranN: "已读取 {{n}} 条消息 — {{s}} 条新建议。",
  goneTitle: '该任务已被删除',
  goneBody: '"{{title}}" 已于 {{at}} 被 {{by}} 删除。',
  goneBodyNoBy: '"{{title}}" 已被删除。',
  missingTitle: '无法打开此任务',
  missingBody: '该任务不存在，或未与您共享。',
  gotIt: '确定',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "f_repeat": "Répétition",
  "r_none": "Ne se répète pas",
  "r_week": "Chaque semaine",
  "r_month": "Chaque mois",
  "r_quarter": "Chaque trimestre",
  "r_year": "Chaque année",
  "r_every": "Tous les",
  "u_week": "semaine(s)",
  "u_month": "mois",
  "u_quarter": "trimestre(s)",
  "u_year": "an(s)",
  "r_until": "Jusqu'au",
  "r_next": "La suivante est due le {{date}} — créée automatiquement lorsque celle-ci est terminée.",
  "r_needDate": "Définissez une échéance pour que les suivantes tombent le bon jour.",
  "r_everyN": "Tous les {{n}} {{unit}}",
  "noteNext": "La prochaine « {{title}} » est sur le tableau — échéance le {{date}}.",
  "log_repeat": "répétition",
  "tl_next": "Prochaine fois",
  "tl_day": "Jours",
  "tl_wd": "Lu,Ma,Me,Je,Ve,Sa,Di",
  "view": "Vue",
  "v_board": "Tableau",
  "v_timeline": "Chronologie",
  "tl_week": "Semaines",
  "tl_month": "Mois",
  "tl_open": "encore ouverte",
  "tl_days": "jours",
  "tl_late": "{{n}} jours de retard",
  "tl_today": "Aujourd'hui",
  "tl_rule": "Une barre va de la date de demande au jour où la tâche a été terminée, sinon à son échéance, sinon à la date de demande + les jours estimés ; à défaut, jusqu'à aujourd'hui.",
  "f_est": "Jours estimés pour terminer",
  "f_estPh": "p. ex. 2 ou 0,5",
  "estN": "{{n}} j",
  "f_requested": "Date de demande",
  "delTitle": "Supprimer cette tâche ?",
  "sortMine": "Mon ordre",
  "sortDue": "Par échéance",
  "sortPrio": "Par priorité",
  "createAgain": "Créer et en ajouter une autre",
  "madeN": "{{n}} créées",
  "nav": "Projets système",
  "title": "Projets système",
  "sub": "Vos tâches et celles qui vous sont confiées, par étape. Faites glisser une carte pour la déplacer ; partagez une tâche, ou tout votre tableau, pour que d'autres puissent la voir ou la modifier.",
  "myBoard": "Mes tâches",
  "boardOf": "Tableau de {{name}}",
  "sharedWithMe": "Partagé avec moi",
  "newTask": "Nouvelle tâche",
  "shareBoard": "Partager mon tableau",
  "search": "Rechercher des tâches…",
  "allPrio": "Toutes priorités",
  "onlyUrgent": "Urgente et haute",
  "anyone": "Tout le monde",
  "assignedMe": "Confiées à moi",
  "createdMe": "Créées par moi",
  "col_backlog": "Backlog",
  "col_todo": "À faire",
  "col_doing": "En cours",
  "col_review": "Revue",
  "col_done": "Terminé",
  "addHere": "Ajouter une tâche ici",
  "quickPh": "Titre de la tâche, puis Entrée",
  "completed": "Terminée",
  "overdue": "En retard",
  "dueToday": "Échéance aujourd'hui",
  "p_normal": "Normale",
  "p_low": "Basse",
  "p_high": "Haute",
  "p_urgent": "Urgente",
  "noTasks": "Rien ici pour l'instant.",
  "readOnly": "Partagé avec vous en lecture",
  "f_title": "Titre",
  "f_body": "Description",
  "f_status": "Étape",
  "f_priority": "Priorité",
  "f_due": "Échéance",
  "f_noRush": "Pas urgent",
  "f_noRushHint": "Non urgent — la personne qui s'en charge choisit une date prévue",
  "f_planned": "Date prévue",
  "frequent": "Fréquent",
  "f_dueNone": "pas de date — dès que possible",
  "f_assignee": "Confiée à",
  "f_nobody": "Personne (moi)",
  "f_tags": "Étiquettes",
  "f_tagsPh": "séparées par des virgules, p. ex. Costing, Q4",
  "f_checklist": "Liste de contrôle",
  "f_addCheck": "Ajouter un élément",
  "f_share": "Partagé avec",
  "f_shareAdd": "Ajouter une personne…",
  "f_canEdit": "peut modifier",
  "f_canView": "peut consulter",
  "f_comments": "Commentaires",
  "f_commentPh": "Écrire un commentaire…",
  "f_send": "Envoyer",
  "f_history": "Historique",
  "f_owner": "Créée par {{name}}",
  "save": "Enregistrer",
  "create": "Créer la tâche",
  "cancel": "Annuler",
  "close": "Fermer",
  "del": "Supprimer",
  "delAsk": "Supprimer « {{title}} » ? Elle disparaît de tous les tableaux.",
  "saved": "Enregistré.",
  "boardShareTitle": "Partager mon tableau",
  "boardShareSub": "Ces personnes voient toutes les tâches que vous avez créées ou qui vous ont été confiées. « Peut modifier » leur permet aussi de modifier les tâches.",
  "boardShareSaved": "Partage du tableau enregistré.",
  "remove": "Retirer",
  "needTitle": "Donnez un titre à la tâche.",
  "loading": "Chargement…",
  "failed": "Une erreur s'est produite ({{status}})",
  "nameLess": "(sans nom)",
  "checkCount": "{{done}}/{{all}}",
  "log_created": "a créé",
  "log_edited": "a modifié",
  "log_moved": "a déplacé",
  "log_deleted": "a supprimé",
  "f_files": "Fichiers et images",
  "f_attach": "Joindre",
  "f_filesHint": "ou déposez des fichiers ici, ou collez une capture d'écran (Ctrl+V) — jusqu'à 20 MB chacun",
  "f_pending": "importés à la création",
  "f_tooBig": "Un fichier peut faire jusqu'à 20 MB.",
  "noAccess": "pas d'accès",
  "noAccessHint": "Cette personne n'a pas accès à System Project : son nom figure sur la tâche, mais elle ne reçoit aucune notification et ne peut pas l'ouvrir.",
  "log_file": "a joint",
  "log_unfile": "a retiré un fichier",
  "v_day": "Ma journée",
  "d_moved": "déplacée de {{from}} → {{to}}",
  "d_created": "créée",
  "d_comment": "a commenté : {{text}}",
  "d_file": "a joint {{name}}",
  "d_unfile": "a retiré {{name}}",
  "d_edited": "a mis à jour {{what}}",
  "d_saved": "a enregistré la tâche",
  "c_edit": "Modifier",
  "c_edited": "modifié",
  "c_editHint": "Entrée pour enregistrer · Échap pour annuler",
  "log_comment_edit": "a modifié un commentaire",
  "d_commentEdit": "a modifié un commentaire",
  "d_prev": "Jour précédent",
  "d_next": "Jour suivant",
  "d_today": "Aujourd'hui",
  "d_none": "Rien n'a été fait sur le tableau le {{date}}.",
  "d_sTasks": "tâches travaillées",
  "d_sDone": "terminées",
  "d_sNew": "créées",
  "d_sMoved": "déplacements",
  "d_sComments": "commentaires",
  "d_sFiles": "fichiers",
  "in_btn": "Suggestions",
  "in_title": "Suggestions issues des e-mails et du chat",
  "in_sub": "Catchy lit vos e-mails, Google Chat et les salons GCC, et liste le travail qu'il y trouve pour vous. Rien n'est ajouté au tableau tant que vous n'avez pas cliqué sur Créer la tâche.",
  "in_none": "Aucune suggestion pour le moment.",
  "in_create": "Créer la tâche",
  "in_dismiss": "Ignorer",
  "in_open": "Ouvrir le message",
  "in_runNow": "Lire maintenant",
  "in_running": "Lecture…",
  "in_connect": "Connecter Gmail et Google Chat",
  "in_reconnect": "Reconnecter Google",
  "in_connected": "Connecté en tant que {{email}}",
  "in_chatOff": "Google Chat non inclus",
  "in_src_gmail": "E-mail",
  "in_src_gchat": "Google Chat",
  "in_src_gcc": "GCC",
  "in_lastRun": "lu {{when}}",
  "in_err": "lecture impossible : {{msg}}",
  "in_notConnected": "non connecté",
  "in_why": "Pourquoi",
  "in_from": "de {{who}}",
  "in_me": "moi",
  "in_excerpt": "Le message",
  "in_ranN": "{{n}} message(s) lu(s) — {{s}} nouvelle(s) suggestion(s).",
  "goneTitle": "Cette tâche a été supprimée",
  "goneBody": "« {{title}} » a été supprimée par {{by}} le {{at}}.",
  "goneBodyNoBy": "« {{title}} » a été supprimée.",
  "missingTitle": "Cette tâche ne peut pas être ouverte",
  "missingBody": "Elle n'existe pas, ou elle n'est pas partagée avec vous.",
  "gotIt": "OK"
};
const ja = {
  "f_repeat": "繰り返し",
  "r_none": "繰り返さない",
  "r_week": "毎週",
  "r_month": "毎月",
  "r_quarter": "四半期ごと",
  "r_year": "毎年",
  "r_every": "間隔",
  "u_week": "週",
  "u_month": "か月",
  "u_quarter": "四半期",
  "u_year": "年",
  "r_until": "終了日",
  "r_next": "次回の期日は {{date}} です — このタスクを完了にすると自動で作成されます。",
  "r_needDate": "次回以降が正しい日に入るよう、期日を設定してください。",
  "r_everyN": "{{n}} {{unit}}ごと",
  "noteNext": "次回の「{{title}}」がボードに追加されました — 期日は {{date}} です。",
  "log_repeat": "繰り返し",
  "tl_next": "次回",
  "tl_day": "日",
  "tl_wd": "月,火,水,木,金,土,日",
  "view": "表示",
  "v_board": "ボード",
  "v_timeline": "タイムライン",
  "tl_week": "週",
  "tl_month": "月",
  "tl_open": "未完了",
  "tl_days": "日",
  "tl_late": "期日を {{n}} 日超過",
  "tl_today": "今日",
  "tl_rule": "バーは依頼日から、完了した日まで、なければ期日まで、それもなければ依頼日＋見積日数まで延びます。いずれもない場合は今日までです。",
  "f_est": "完了までの見積日数",
  "f_estPh": "例：2 または 0.5",
  "estN": "{{n}}日",
  "f_requested": "依頼日",
  "delTitle": "このタスクを削除しますか？",
  "sortMine": "自分の並び順",
  "sortDue": "期日順",
  "sortPrio": "優先度順",
  "createAgain": "作成して続けて追加",
  "madeN": "{{n}} 件作成しました",
  "nav": "システムプロジェクト",
  "title": "システムプロジェクト",
  "sub": "自分のタスクと自分に割り当てられたタスクを、ステージ別に表示します。カードをドラッグして移動できます。タスクまたはボード全体を共有すると、他の人が閲覧・編集できます。",
  "myBoard": "自分のタスク",
  "boardOf": "{{name}} のボード",
  "sharedWithMe": "共有されたもの",
  "newTask": "新規タスク",
  "shareBoard": "自分のボードを共有",
  "search": "タスクを検索…",
  "allPrio": "すべての優先度",
  "onlyUrgent": "緊急と高",
  "anyone": "全員",
  "assignedMe": "自分に割り当て",
  "createdMe": "自分が作成",
  "col_backlog": "バックログ",
  "col_todo": "未着手",
  "col_doing": "進行中",
  "col_review": "レビュー",
  "col_done": "完了",
  "addHere": "ここにタスクを追加",
  "quickPh": "タスク名を入力して Enter",
  "completed": "完了済み",
  "overdue": "期限超過",
  "dueToday": "本日期日",
  "p_normal": "通常",
  "p_low": "低",
  "p_high": "高",
  "p_urgent": "緊急",
  "noTasks": "まだ何もありません。",
  "readOnly": "閲覧のみで共有されています",
  "f_title": "タイトル",
  "f_body": "説明",
  "f_status": "ステージ",
  "f_priority": "優先度",
  "f_due": "期日",
  "f_noRush": "急ぎではない",
  "f_noRushHint": "急ぎではありません — 担当者が予定日を決めます",
  "f_planned": "予定日",
  "frequent": "よく使う",
  "f_dueNone": "日付なし — できるだけ早く",
  "f_assignee": "担当者",
  "f_nobody": "なし（自分）",
  "f_tags": "タグ",
  "f_tagsPh": "カンマ区切り。例：Costing, Q4",
  "f_checklist": "チェックリスト",
  "f_addCheck": "項目を追加",
  "f_share": "共有先",
  "f_shareAdd": "ユーザーを追加…",
  "f_canEdit": "編集可",
  "f_canView": "閲覧のみ",
  "f_comments": "コメント",
  "f_commentPh": "コメントを入力…",
  "f_send": "送信",
  "f_history": "履歴",
  "f_owner": "作成者：{{name}}",
  "save": "保存",
  "create": "タスクを作成",
  "cancel": "キャンセル",
  "close": "閉じる",
  "del": "削除",
  "delAsk": "「{{title}}」を削除しますか？ すべてのボードから消えます。",
  "saved": "保存しました。",
  "boardShareTitle": "自分のボードを共有",
  "boardShareSub": "ここに追加した人は、あなたが作成した、またはあなたに割り当てられたすべてのタスクを見ることができます。「編集可」にするとタスクの変更もできます。",
  "boardShareSaved": "ボードの共有を保存しました。",
  "remove": "削除",
  "needTitle": "タスクのタイトルを入力してください。",
  "loading": "読み込み中…",
  "failed": "問題が発生しました ({{status}})",
  "nameLess": "（名前なし）",
  "checkCount": "{{done}}/{{all}}",
  "log_created": "作成",
  "log_edited": "編集",
  "log_moved": "移動",
  "log_deleted": "削除",
  "f_files": "ファイルと画像",
  "f_attach": "添付",
  "f_filesHint": "ここにファイルをドロップするか、スクリーンショットを貼り付けてください (Ctrl+V) — 1ファイルあたり20 MBまで",
  "f_pending": "作成時にアップロード",
  "f_tooBig": "ファイルは20 MBまでです。",
  "noAccess": "アクセス権なし",
  "noAccessHint": "この人は System Project を利用できません。タスクに名前は表示されますが、通知は届かず、開くこともできません。",
  "log_file": "添付",
  "log_unfile": "ファイルを削除",
  "v_day": "今日の作業",
  "d_moved": "{{from}} → {{to}} に移動",
  "d_created": "作成",
  "d_comment": "コメント：{{text}}",
  "d_file": "{{name}} を添付",
  "d_unfile": "{{name}} を削除",
  "d_edited": "{{what}} を更新",
  "d_saved": "タスクを保存",
  "c_edit": "編集",
  "c_edited": "編集済み",
  "c_editHint": "Enterで保存 · Escでキャンセル",
  "log_comment_edit": "コメントを変更",
  "d_commentEdit": "コメントを変更",
  "d_prev": "前の日",
  "d_next": "次の日",
  "d_today": "今日",
  "d_none": "{{date}} にボードで行われた作業はありません。",
  "d_sTasks": "作業したタスク",
  "d_sDone": "完了",
  "d_sNew": "作成",
  "d_sMoved": "移動",
  "d_sComments": "コメント",
  "d_sFiles": "ファイル",
  "in_btn": "提案",
  "in_title": "メールとチャットからの提案",
  "in_sub": "Catchy があなたのメール、Google Chat、GCC のルームを読み、見つけた作業を一覧にします。「タスクを作成」を押すまで、ボードには何も追加されません。",
  "in_none": "現在、提案はありません。",
  "in_create": "タスクを作成",
  "in_dismiss": "却下",
  "in_open": "メッセージを開く",
  "in_runNow": "今すぐ読み込む",
  "in_running": "読み込み中…",
  "in_connect": "Gmail と Google Chat を接続",
  "in_reconnect": "Google を再接続",
  "in_connected": "{{email}} で接続済み",
  "in_chatOff": "Google Chat は含まれていません",
  "in_src_gmail": "メール",
  "in_src_gchat": "Google Chat",
  "in_src_gcc": "GCC",
  "in_lastRun": "{{when}} に読み込み",
  "in_err": "読み込めませんでした：{{msg}}",
  "in_notConnected": "未接続",
  "in_why": "理由",
  "in_from": "{{who}} より",
  "in_me": "自分",
  "in_excerpt": "メッセージ",
  "in_ranN": "{{n}} 件のメッセージを読み込みました — 新しい提案 {{s}} 件。",
  "goneTitle": "このタスクは削除されました",
  "goneBody": "「{{title}}」は {{by}} により {{at}} に削除されました。",
  "goneBodyNoBy": "「{{title}}」は削除されました。",
  "missingTitle": "このタスクを開けません",
  "missingBody": "存在しないか、あなたに共有されていません。",
  "gotIt": "OK"
};

const dictionary = { ns: 'xTask', en, ko, vi, zh, fr, ja };

export default dictionary;
